import { Alert } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useCurrentUser } from '@feature/security';
import { formatDate } from '@feature/utils';

import { TravelRequest, isTravelReturnDatePending } from '../model/TravelRequestTypes';

interface TravelRequestReturnDateNoticeProps {
  request: TravelRequest;
}

export function TravelRequestReturnDateNotice({ request }: TravelRequestReturnDateNoticeProps) {
  const { t } = useTranslation();
  const currentUser = useCurrentUser();
  const isRequester = request.requester.id === currentUser.id;

  if (request.returnDate == null || !isTravelReturnDatePending(request, isRequester, currentUser.currentRole)) {
    return null;
  }

  return (
    <Alert color="blue">
      {t('travel.requests.complete.returnDateNotPassed', { date: formatDate(request.returnDate) })}
    </Alert>
  );
}
